import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import axios from "axios";

export default {
    plugins: [createPersistedState()],
    state: {
        user: null,
    },
    mutations: {
        setUser(state, user) {
            state.user = user;
        },
        clearUser(state) {
            state.user = null;
            console.log("logout");
        },
    },
    actions: {
        async fetchUser({ commit }) {
            try {
                const response = await axios.get(`/api/user`);
                // console.log(response.data.data);
                commit("setUser", response.data.data);
            } catch (error) {
                console.error(error);
            }
        },
    },
};
